import { useMutation, useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { QueryKeys } from '../../core/queries/query-keys.constants';

export function useQueryGetRegistrationPageOptional(projectID?: string, registrationPageID?: string) {
  const api = useApi();

  return useQuery([QueryKeys.PROJECTS, projectID, QueryKeys.REGISTRATION_PAGES, registrationPageID], async () => {
    if (!projectID || !registrationPageID) {
      return undefined;
    }
    return await api.projectsSettingsController.findOne(projectID, registrationPageID);
  });
}

export function useMutationDeleteRegistrationPage() {
  const api = useApi();

  return useMutation(async ({ projectID, registrationPageID }: { projectID: string; registrationPageID: string }) => {
    return await api.projectsSettingsController.delete(projectID, registrationPageID);
  });
}

export function useMutationCreateRegistrationPage() {
  const api = useApi();

  return useMutation(
    async ({
      projectID,
      settings,
      settingsSchemaID
    }: {
      projectID: string;
      settingsSchemaID: string;
      settings: Record<string, any>;
    }) => {
      try {
        return await api.projectsSettingsController.create(projectID, settingsSchemaID, settings);
      } catch (err: any) {
        if (err.name === 'RestError' && err.response?.status === 201 && err.response.parsedBody) {
          // Workaround: treat this as a success
          return err.response.parsedBody;
        }

        throw err;
      }
    }
  );
}

export function useMutationUpdateRegistrationPage() {
  const api = useApi();

  return useMutation(
    async ({
      registrationPageID,
      projectID,
      settings
    }: {
      projectID: string;
      registrationPageID: string;
      settings: Record<string, any>;
    }) => {
      return await api.projectsSettingsController.update(projectID, registrationPageID, settings);
    }
  );
}
